<template>
  <div class="pa-4">
    <h3 class="font-weight-bold mb-4">{{ title }} Triggers</h3>
    <div v-for="(trigger, index) in triggers" :key="index" class="my-2">
      <div class="hyp-trigger">
        <div
          class="pa-0 pr-2 hyp-trigger-status-image"
          v-html="getTriggerStatusIcon(trigger)"
        ></div>
        <div class="hyp-trigger-text pa-0" v-html="trigger.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import lodashFind from "lodash/find";

import { SCENARIOS_TRIGGER_STATUS } from "@/common/constants/controlRisks/scenarios";

export default {
  name: "RisksScenariosTriggers",
  components: {},
  props: {
    title: {
      type: String,
    },
    triggers: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTriggerStatusIcon(trigger) {
      return lodashFind(SCENARIOS_TRIGGER_STATUS, [
        "statusName",
        trigger.statusName,
      ])?.iconSvg;
    },
  },
};
</script>

<style scoped>
.hyp-trigger {
  display: flex;
}
.v-application .font-weight-bold {
  font-weight: 700 !important;
}
</style>
<style>
.hyp-trigger-text p {
  margin-bottom: 0px !important;
}
.hyp-trigger-status-image svg {
  width: 20px !important;
  fill: gray;
  background-color: white !important;
}
</style>
